module.exports = __webpack_public_path__ + "img/header_shadow.aaa81cd0.png";